import React from 'react';
import { CheckCircleIcon, ClockIcon, BrainIcon } from 'lucide-react';
export const Solution = () => {
  return <section className="w-full bg-gradient-to-b from-blue-50 to-pink-50 py-12 px-4 md:px-8" data-id="element-330">
      <div className="max-w-5xl mx-auto" data-id="element-331">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-8 text-center" data-id="element-332">
          Przełomowe odkrycie: 15-minutowa metoda regeneracji emocjonalnej
        </h2>
        {/* Research results */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-333">
          <p className="text-gray-700 mb-4" data-id="element-334">
            W swoich badaniach dr Radacka odkryła coś niesamowitego:
          </p>
          <div className="bg-pink-50 border-l-4 border-pink-500 p-4 my-6" data-id="element-335">
            <p className="text-gray-700 italic" data-id="element-336">
              "Kobiety, które codziennie przez 15 minut praktykowały specyficzną
              metodę regeneracji emocjonalnej, po 21 dniach wykazywały:*
            </p>
            <div className="mt-4 space-y-3" data-id="element-337">
              <div className="flex items-center" data-id="element-338">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-339" />
                <p className="text-gray-700" data-id="element-340">
                  Obniżenie poziomu kortyzolu o 34%
                </p>
              </div>
              <div className="flex items-center" data-id="element-341">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-342" />
                <p className="text-gray-700" data-id="element-343">
                  Poprawę kontroli emocjonalnej o 67%
                </p>
              </div>
              <div className="flex items-center" data-id="element-344">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-345" />
                <p className="text-gray-700" data-id="element-346">
                  Wzrost poczucia własnej wartości o 45%
                </p>
              </div>
            </div>
            <p className="text-gray-700 italic mt-4" data-id="element-347">
              Ale kluczowe było ODKRYCIE DLACZEGO to działa..."
            </p>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-348">Dr Radacka wyjaśniła mechanizm:</p>
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 my-4" data-id="element-349">
            <p className="text-gray-700 italic" data-id="element-350">
              "15 minut to dokładnie tyle, ile potrzeba mózgowi, żeby przejść z
              'trybu alarmowego' w 'tryb regeneracji'. Krócej - nie wystarcza.
              Dłużej - mózg wraca do stresu, bo zaczyna myśleć o obowiązkach."
            </p>
          </div>
          <p className="text-gray-700 font-bold text-center my-6" data-id="element-351">
            To nie była kolejna technika relaksacyjna. To była nauka.
          </p>
          <p className="text-gray-700" data-id="element-352">
            Ale najważniejsze było to, że dr Radacka opracowała konkretny
            protokół - krok po kroku - jak to robić.
          </p>
        </div>
        {/* Scientific explanation with visual */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-353">
          <div className="md:flex items-center" data-id="element-354">
            <div className="md:w-1/2 mb-6 md:mb-0 md:pr-6" data-id="element-355">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-356">
                Jak działa 15-minutowa metoda regeneracji?
              </h3>
              <div className="space-y-4" data-id="element-357">
                <div className="flex items-start" data-id="element-358">
                  <div className="bg-red-100 rounded-full p-2 mr-3 mt-1" data-id="element-359">
                    <BrainIcon className="h-5 w-5 text-red-600" data-id="element-360" />
                  </div>
                  <div data-id="element-361">
                    <p className="font-bold text-gray-800" data-id="element-362">
                      Faza 1: Reset neurologiczny
                    </p>
                    <p className="text-gray-700" data-id="element-363">
                      Pierwsze 5 minut pozwala twojemu mózgowi przerwać ciągły
                      cykl alarmowy
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-364">
                  <div className="bg-blue-100 rounded-full p-2 mr-3 mt-1" data-id="element-365">
                    <ClockIcon className="h-5 w-5 text-blue-600" data-id="element-366" />
                  </div>
                  <div data-id="element-367">
                    <p className="font-bold text-gray-800" data-id="element-368">
                      Faza 2: Stabilizacja emocjonalna
                    </p>
                    <p className="text-gray-700" data-id="element-369">
                      Kolejne 5 minut przywraca równowagę między układem
                      współczulnym a przywspółczulnym
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-370">
                  <div className="bg-green-100 rounded-full p-2 mr-3 mt-1" data-id="element-371">
                    <CheckCircleIcon className="h-5 w-5 text-green-600" data-id="element-372" />
                  </div>
                  <div data-id="element-373">
                    <p className="font-bold text-gray-800" data-id="element-374">
                      Faza 3: Regeneracja zasobów
                    </p>
                    <p className="text-gray-700" data-id="element-375">
                      Ostatnie 5 minut umożliwia odbudowę zasobów psychicznych
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg mt-6" data-id="element-376">
                <p className="text-sm text-gray-600" data-id="element-377">
                  * Wyniki badania opublikowanego w Journal of Caregiver
                  Psychology, 2023
                </p>
              </div>
            </div>
            <div className="md:w-1/2" data-id="element-378">
              <img src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="Kobieta praktykująca metodę regeneracji" className="rounded-lg shadow-md w-full" data-id="element-379" />
              <div className="mt-4 bg-pink-100 rounded-lg p-4 text-center" data-id="element-380">
                <p className="text-pink-800 font-bold" data-id="element-381">
                  "Po 21 dniach praktyki 94% kobiet odczuło znaczącą poprawę"
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* The e-book discovery */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-382">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-383">
            Szukałam dalej, bo musiałam wiedzieć więcej
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-384">
            Im więcej czytałam o badaniach dr Radackiej, tym bardziej wszystko
            zaczynało mieć sens. Opisywała dokładnie to, co czułam:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6" data-id="element-385">
            <div className="flex items-center" data-id="element-386">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-387" />
              <p className="text-gray-700" data-id="element-388">Wybuchy złości z błahych powodów</p>
            </div>
            <div className="flex items-center" data-id="element-389">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-390" />
              <p className="text-gray-700" data-id="element-391">Uczucie, że "znikam" jako osoba</p>
            </div>
            <div className="flex items-center" data-id="element-392">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-393" />
              <p className="text-gray-700" data-id="element-394">
                Fizyczne objawy stresu: bóle głowy, napięcie w karku
              </p>
            </div>
            <div className="flex items-center" data-id="element-395">
              <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-396" />
              <p className="text-gray-700" data-id="element-397">
                Poczucie winy, że nie daję rady być "idealną" dla wszystkich
              </p>
            </div>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-398">
            Ale najważniejsze było rozwiązanie:
          </p>
          <div className="bg-pink-50 border-l-4 border-pink-500 p-4 my-4" data-id="element-399">
            <p className="text-gray-700 italic" data-id="element-400">
              "Nie chodzi o wielkie zmiany. Nie musisz rewolucjonizować swojego
              życia. Musisz tylko zastosować naukowy protokół 15-minutowej
              regeneracji. To jedyna metoda, która działa na kobiety w Twojej
              sytuacji."
            </p>
          </div>
          <div className="mt-8 text-center" data-id="element-401">
            <a href="https://veiramode.com/products/nie-zapomnij-o-sobie-ebook" className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all" data-id="element-402">
              Odkryj e-book z protokołem 15-minutowej regeneracji →
            </a>
          </div>
        </div>
      </div>
    </section>;
};